export const GET_SUBDOMAIN = '[Subdomain] Get subdomain';
export const GET_SUBDOMAIN_SUCCESS = '[Subdomain] Get subdomain Success';
export const GET_SUBDOMAIN_ERROR = '[Subdomain] Get subdomain Error';

export const QUERY_SUBDOMAIN = '[Subdomain] Query subdomain';
export const QUERY_SUBDOMAIN_SUCCESS = '[Subdomain] Query subdomain Success';
export const QUERY_SUBDOMAIN_ERROR = '[Subdomain] Query subdomain Error';

export const UPDATE_SUBDOMAIN = '[Subdomain] Update subdomain';
export const UPDATE_SUBDOMAIN_SUCCESS = '[Subdomain] Update subdomain Success';
export const UPDATE_SUBDOMAIN_ERROR = '[Subdomain] Update subdomain Error';